/**
 * The magnifier used by both the trigger and the search field, matching the design's `Loop`.
 *
 * Defaults to the design's band size (20). At 16 it read as decoration in the header rather than
 * as the site's search affordance.
 */
export function SearchIcon({ size = 20 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
      <circle cx="11" cy="11" r="6.5" stroke="currentColor" strokeWidth="1.8" />
      <path d="M16 16l4.5 4.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}
